<template>
<div v-if="appLoaded">
  <app-loading></app-loading>

  <contact-form :requiredFields='["email"]'
    submitUrl="/wp-json/sw-immoapp/v1/contact/expose-contact"
    :authentication-token="authenticationToken"
    :prop-immo-expose="[exposeId, customObjectId]"
  >
    <contact-logged-in></contact-logged-in>
    <contact-fields v-if="loggedIn" :include="['contactReason']" :exclude="['company', 'person', 'phone_email']"></contact-fields>
    <contact-fields v-else :include="['contactReason']" :exclude="['company']"></contact-fields>
  </contact-form>
</div>
</template>

<script>
import AppLoading from "../AppLoading.vue";
import ContactLoggedIn from "./ContactLoggedIn";
import ContactForm from "../../contact/ContactForm";
import ContactFields from "../../contact/ContactFields";

export default {
  name: "ExposeContactStandaloneApp",

  components: {
    AppLoading,
    ContactForm,
    ContactFields,
    ContactLoggedIn
  },

  props: [
    "exposeId",
    "customObjectId"
  ],

  computed: {
    loggedIn() {
      return this.$store.state.user.loggedIn;
    },

    username() {
      return this.$store.state.user.email;
    },

    appLoaded() {
      return this.$store.state.appLoaded;
    },

    authenticationToken() {
      return this.$store.state.auth.authenticationToken;
    }
  }
};
</script>
